import React, { ReactNode } from 'react';
import { Card, CardProps } from '@mui/material';
import { useMediaQuery } from "@mui/material";


interface CustomCardProps extends CardProps {
  children: ReactNode;
}

const CustomCard: React.FC<CustomCardProps> = ({
  children,
  sx,
  ...props
}) => {
  const isDesktop = useMediaQuery('(min-width: 600px)');

  return (
    <Card
      sx={{
        boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.2)',
        borderRadius: '16px',
        overflow: 'hidden',
        transition: 'box-shadow 0.3s ease',
        width: '97%',
        maxWidth: isDesktop ? '500px' : '97%',
        '&:hover': {
          boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.25)',
        },
        ...sx
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

export default CustomCard;